module.exports = __webpack_public_path__ + "img/logo.befd0a4e.svg";